import { useState, type FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9u4l8d3pcjqs2fcsm4g';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('contact_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setErrorMsg(msg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=closeup%20of%20delicate%20cherry%20blossom%20branches%20against%20soft%20sunset%20sky%2C%20pink%20petals%20gently%20illuminated%20by%20warm%20golden%20hour%20light%2C%20dreamy%20bokeh%20background%2C%20romantic%20spring%20evening%20atmosphere%2C%20fine%20art%20nature%20photography%20with%20ethereal%20mood%20and%20soft%20pastel%20tones&width=1600&height=600&seq=sakura-cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-primary-900/70"></div>
      <div className="relative z-10 max-w-2xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white">
          开始你的樱花之旅
        </h2>
        <p className="mt-4 text-sm md:text-base text-white/70 leading-relaxed">
          订阅樱花视频，第一时间获取最新樱花盛开视频和赏樱攻略推送
          <br className="hidden sm:block" />
          不错过每一场樱花盛开的浪漫
        </p>
        <form
          onSubmit={handleSubmit}
          className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <input
            type="email"
            name="email"
            placeholder="输入你的邮箱地址"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 px-5 py-3 rounded-full bg-white/15 border border-white/20 text-white placeholder-white/50 text-sm outline-none focus:border-white/40 transition-colors"
          />
          <input
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3 rounded-full bg-white text-primary-700 font-medium text-sm hover:bg-primary-50 transition-all duration-300 whitespace-nowrap disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '免费订阅'}
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-4 text-sm text-green-300">订阅成功！感谢你的关注。</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-300">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}